const initProgressBar = () => {
  const progress = document.querySelector('.progress-completed');
  if (progress) {
    progress.style.width = progress.getAttribute('data-complete') + '%';
    progress.style.opacity = 1;
  }
}

export { initProgressBar };
